import httpClient from "@/api/config/httpClient";
import { ShoppingCartAdapter, ShoppingCartBundlesPromotionsAndContractsDto } from "@/api/shopping-cart";
import { ExtendedShoppingCartBundlePromotionsAndContracts, ExtendedShoppingCartBundlesPromotionsAndContracts } from "@/models/shopping-cart.model";

export abstract class MainSaleProcessShoppingCartService {
	private static readonly BASE_URL = "/sys03/main-sale-processes/shopping-carts";

	public static fetchPromotionsAndContracts(id: string): Promise<ExtendedShoppingCartBundlesPromotionsAndContracts> {
		const url = `${MainSaleProcessShoppingCartService.BASE_URL}/${id}/promotions-and-contracts`;
		return httpClient.get(url).then((response) => {
			const { data } = response;

			return ShoppingCartAdapter.extendShoppingCartBundlesPromotionsAndContractsDto(data);
		});
	}

	public static updatePromotions({
		id,
		bundles = []
	}: {
		id: string;
		bundles: ExtendedShoppingCartBundlePromotionsAndContracts[];
	}): Promise<ExtendedShoppingCartBundlesPromotionsAndContracts> {
		const url = `${MainSaleProcessShoppingCartService.BASE_URL}/${id}/promotions`;

		const body = ShoppingCartAdapter.buildUpdateShoppingCartPromotionsDto({ bundles, applyDefaultContract: true });

		return httpClient.put<ShoppingCartBundlesPromotionsAndContractsDto>(url, body).then((response) => {
			const { data } = response;

			return ShoppingCartAdapter.extendShoppingCartBundlesPromotionsAndContractsDto(data);
		});
	}

	public static updateContracts({
		id,
		bundles = []
	}: {
		id: string;
		bundles: ExtendedShoppingCartBundlePromotionsAndContracts[];
	}): Promise<ExtendedShoppingCartBundlesPromotionsAndContracts> {
		const url = `${MainSaleProcessShoppingCartService.BASE_URL}/${id}/contracts`;

		const body = ShoppingCartAdapter.buildUpdateShoppingCartContractsDto({ bundles });

		return httpClient.put<ShoppingCartBundlesPromotionsAndContractsDto>(url, body).then((response) => {
			const { data } = response;

			return ShoppingCartAdapter.extendShoppingCartBundlesPromotionsAndContractsDto(data);
		});
	}
}
